import type { SwiperProps } from 'swiper/react'

export const carouselMapper = {
  autoSlideView: {
    breakpoints: {
      400: { slidesPerView: 'auto', slidesPerGroup: 1 },
      700: { slidesPerView: 'auto' },
    },
  },
} satisfies Record<string, SwiperProps>

export type CarouselMapperKey = keyof typeof carouselMapper
